import styled from 'styled-components'
import { useTranslation } from 'react-i18next'
import { Box, IconArrowUpRight, Skeleton } from '@machobear/design-system'
import { getImageUrl } from '@/utils/image'
import CornerRibbon from './corner-ribbon'
import { useListingData } from '../../context/listing-data'
import { useListingActions } from '../../context/listing-actions'

const ListingImage = styled.img`
  object-fit: cover;
  object-position: center center;
  min-width: 100%;
  height: 168px;
  width: 252px;
  border-radius: 6px;
`

const LinkCircle = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: #f3f5f7;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: #eaecf1;
  }
`

export const CoverImage = () => {
  const { t } = useTranslation()

  const { goToPublicLink } = useListingActions()

  const { coverPhoto, listingSponsored, loading } = useListingData()

  if (loading) return <Skeleton.Shape height="168px" width="252px" />

  if (!coverPhoto) return null

  const imageUrl = getImageUrl(coverPhoto.aws_s3_key, { fit: 'fit-in/252x168', quality: 100 })

  return (
    <Box
      position="relative"
      borderRadius="standard"
      cursor="pointer"
      onClick={goToPublicLink}
      overflow="hidden"
      height="full"
    >
      {listingSponsored && <CornerRibbon>{t('Sponsored')}</CornerRibbon>}
      <ListingImage src={imageUrl as string} alt={t('Listing image')} />
      <LinkCircle>
        <IconArrowUpRight />
      </LinkCircle>
    </Box>
  )
}
